import { useState } from "react";
import { createContext } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import { editImageAdminService } from "../../../services/adminServices";
import { setMetaAction } from "../../../redux/actions/metaActions/metaActions";

export const imageAdminContext = createContext({
  homeBanner: "",
  setHomeBanner: () => {},
  menuBanner: "",
  setMenuBanner: () => {},
  serviceBanner: "",
  setServiceBanner: () => {},
  galleryBanner: "",
  setGalleryBanner: () => {},
  homeCarousel: [],
  setHomeCarousel: () => {},
  gallery: [],
  setGallery: () => {},
  handleEditImage: () => {},
});

const ImageAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [homeBanner, setHomeBanner] = useState("");
  const [menuBanner, setMenuBanner] = useState("");
  const [serviceBanner, setServiceBanner] = useState("");
  const [galleryBanner, setGalleryBanner] = useState("");
  const [homeCarousel, setHomeCarousel] = useState([]);
  const [gallery, setGallery] = useState([]);

  // Handle Edit Image
  const handleEditImage = async (event) => {
    event?.preventDefault();

    const objData = {
      homeBanner,
      menuBanner,
      serviceBanner,
      galleryBanner,
      homeCarousel,
      gallery,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editImageAdminService(objData);
      if (status === 200) {
        dispatch(setMetaAction());
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <imageAdminContext.Provider
        value={{
          homeBanner,
          setHomeBanner,
          menuBanner,
          setMenuBanner,
          serviceBanner,
          setServiceBanner,
          galleryBanner,
          setGalleryBanner,
          homeCarousel,
          setHomeCarousel,
          gallery,
          setGallery,
          handleEditImage,
        }}
      >
        {children}
      </imageAdminContext.Provider>
    </>
  );
};

export default ImageAdminContext;
